import type { StateCreator } from 'zustand'

import { type PageTrasitionState, INITIAL_STATE } from './type'

const createPageTransitionSlice: StateCreator<PageTrasitionState, [], [], PageTrasitionState> = (
  set,
) => ({
  pageTrasition: INITIAL_STATE,
  setPageTrasitionDirection: (direction) => set(() => ({ pageTrasition: { direction } })),
})

export default createPageTransitionSlice
